import { useLocalStorageString } from '../../storage/utils';
import { Storage } from '~/shared/utils/storage';

export default function useActiveCustomerId() {
    return useLocalStorageString(Storage.activeCustomerId, undefined);
}
